module.exports = new __parcel__URL__("connected_earth_agriculture.a9b25ef8.png").toString();